import { useState } from 'react'
import ControlButton from 'ui/components/ControlButton'
import Select from 'ui/components/forms/Select/'
import Icon from 'ui/components/Icon'
import { notifyError } from 'ui/components/Notify'
import {
  AddButtonWrap,
  DeleteButtonWrap,
  SelectCol,
  SelectRow,
  SelectWrapper,
} from './styled'

export function SelectNewUser({
  userList,
  roleList,
  priceList,
  hasEstimate,
  updateProjectUserMutation,
  updateUserList,
  slug,
}) {
  const [newUser, setNewUser] = useState(null)
  const addUser = () => {
    if (!newUser?.userId || !newUser?.roleId) {
      return notifyError('Введите имя пользователя или роль')
    }
    if (!newUser?.priceId && hasEstimate) {
      return notifyError(
        'Роль из сметы обязательна при наличии сметы в проекте'
      )
    }
    const roles = Array.isArray(newUser.roleId)
      ? newUser.roleId
      : [newUser.roleId]

    roles.forEach((role) =>
      updateProjectUserMutation({
        slug,
        userId: newUser?.userId,
        roleId: role,
        priceId: newUser?.priceId ? newUser?.priceId : null,
      })
    )

    setNewUser(null)
  }

  return (
    <>
      {newUser && (
        <SelectRow>
          <SelectCol>
            <SelectWrapper>
              <Select
                label="Имя"
                id={`nameSelect`}
                options={userList}
                onChange={(value) => {
                  setNewUser((user) => ({
                    ...user,
                    userId: value.id,
                    ...value,
                  }))
                }}
                placeholder="Имя"
                maxHeight="200px"
                defaultValue={''}
              />
            </SelectWrapper>
          </SelectCol>
          <SelectCol>
            <Select
              placeholder="Роль"
              id={`roleSelect`}
              required
              options={roleList}
              onChange={(value) => {
                setNewUser((user) => ({
                  ...user,
                  roleId: value.id,
                }))
              }}
              maxHeight="200px"
            />
          </SelectCol>
          <SelectCol>
            <Select
              placeholder="Роль из сметы"
              id={`priceRoleSelect`}
              options={priceList}
              onChange={(value) => {
                setNewUser((user) => ({
                  ...user,
                  priceId: value.id,
                }))
              }}
              maxHeight="200px"
              required={hasEstimate}
            />
          </SelectCol>
          <DeleteButtonWrap>
            <ControlButton theme="edit" onClick={addUser}>
              Подтвердить
            </ControlButton>
          </DeleteButtonWrap>
        </SelectRow>
      )}

      {!newUser && (
        <AddButtonWrap>
          <ControlButton
            theme="base"
            onClick={() => {
              setNewUser({})
              updateUserList()
            }}
          >
            <Icon name="plus-tag" size={16} />
            Добавить сотрудника
          </ControlButton>
        </AddButtonWrap>
      )}
    </>
  )
}
